import { render, staticRenderFns } from "./myPlansSettingsForm.vue?vue&type=template&id=c4562116&scoped=true&"
import script from "./myPlansSettingsForm.vue?vue&type=script&lang=js&"
export * from "./myPlansSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./myPlansSettingsForm.vue?vue&type=style&index=0&id=c4562116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4562116",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QBtn,QScrollArea});
